import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import {
  activeLeaguesSelector,
  activeLeagues,
} from '../../redux/features/activeLeagueSlice'
import ActiveLeaguesListItem from './ActiveLeaguesListItem'
import Typography from '@mui/material/Typography'

export default function ActiveLeaguesList() {
  const dispatch = useDispatch()
  const { leagues } = useSelector(activeLeaguesSelector)

  useEffect(() => {
    dispatch(activeLeagues())
  }, [dispatch])

  if (leagues !== null && leagues.length > 0) {
    return (
      <Box sx={{marginBottom: '0.8rem'}}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontSize: '1.3rem',
            color: 'constants.orange',
            fontWeight: 'bold',
            paddingBottom: 0,
            borderBottom: 'solid 1px',
            padding: 'inherit',
            margin: '0 1rem',
          }}
        >
          Giải đấu
        </Typography>
        <List>
          {leagues.map((value, index) => {
            return <ActiveLeaguesListItem key={index} league={value} />
          })}
        </List>
      </Box>
    )
  }

  return (
    <Box>
      <List></List>
    </Box>
  )
}
